import { useEffect } from 'react';
import { readCookieConsent } from '@/lib/cookieConsent';
import { COOKIE_CONSENT_UPDATED_EVENT, initSentryIfAnalyticsAllowed } from '@/lib/sentryInit';

/** Applies stored cookie consent on load; gates Sentry init on Analytics preference. */
export function SentryConsentBridge() {
  useEffect(() => {
    const stored = readCookieConsent();
    void initSentryIfAnalyticsAllowed(Boolean(stored?.analytics));

    const onUpdate = (event: Event) => {
      const detail = (event as CustomEvent<{ analytics?: boolean }>).detail;
      const analytics = detail?.analytics ?? readCookieConsent()?.analytics ?? false;
      void initSentryIfAnalyticsAllowed(Boolean(analytics));
    };

    window.addEventListener(COOKIE_CONSENT_UPDATED_EVENT, onUpdate);
    return () => window.removeEventListener(COOKIE_CONSENT_UPDATED_EVENT, onUpdate);
  }, []);

  return null;
}
